var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "client-title--xxxl"
  }, [_vm._v("캠페인 후원")])]), _c('campaign-tabs'), _c('v-row')], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }